import React, { Component } from "react";
import * as Icon from "react-feather";

import PlaybookBuildService from "../../services/PlaybookBuildService";

import "./build-page.css";
import "./playbook-build-page.css";

class PlaybookBuildSkillsCard extends Component {
	constructor(props) {
		super(props);
		this.state = { isAboutGuideShown: false };
	}

	onToggleAboutGuide = () => {
		this.setState(previous => ({ isAboutGuideShown: !previous.isAboutGuideShown }));
	};

	describeToolReads = ({ tool }) => {
		if (!tool.needs) return "";
		const source = this.props.session.sourceCatalogue.find(candidate => candidate.key === tool.needs);
		const readsText = `Reads ${source.label}`;
		return readsText;
	};

	renderSkill = skill => {
		const { session, onSetSkillRemoved } = this.props;
		return (
			<div key={skill.id} className="playbook-build__skill">
				<Icon.BookOpen size={13} className="playbook-build__skill-icon" />
				<span>
					<strong>
						{skill.name} <span className="tk-muted">v{skill.versionNumber}</span>
					</strong>
					{skill.reason && <span className="playbook-build__skill-reason">{skill.reason}</span>}
				</span>
				{session.status === "open" && (
					<button
						type="button"
						className="playbook-build__source-remove"
						onClick={() => onSetSkillRemoved({ skillId: skill.id, isRemoved: true })}
						aria-label={`Remove ${skill.name}`}
						title={`Remove ${skill.name} — the guide will not use it`}
					>
						<Icon.X size={14} />
					</button>
				)}
			</div>
		);
	};

	renderRemovedSkills() {
		const { session, onSetSkillRemoved } = this.props;
		if (session.removedSkills.length === 0) return null;
		return (
			<div className="playbook-build__removed-skills">
				<span className="tk-text-strong">Removed</span>
				{session.removedSkills.map(skill => (
					<span key={skill.id} className="playbook-build__removed-skill">
						{skill.name}
						{session.status === "open" && (
							<button type="button" className="tk-text-action tk-text-action--muted" onClick={() => onSetSkillRemoved({ skillId: skill.id, isRemoved: false })}>
								Add back
							</button>
						)}
					</span>
				))}
			</div>
		);
	}

	renderTools({ tools }) {
		if (tools.length === 0) return null;
		return (
			<div className="playbook-build__tools">
				{tools.map(tool => (
					<span key={tool.name} className="playbook-build__tool" title={this.describeToolReads({ tool })}>
						{tool.label}
					</span>
				))}
			</div>
		);
	}

	render() {
		const { session } = this.props;
		const { draft } = session;
		const { skills, tools } = PlaybookBuildService.skillsAndToolsShown({ session });
		const isDraftBehind = PlaybookBuildService.isDraftBehindOnSkills({ session });
		const { isAboutGuideShown } = this.state;
		const guidingSkillNames = session.guidingSkills.map(skill => `${skill.name} v${skill.versionNumber}`);
		const guidedByText = `Guided by ${guidingSkillNames.join(" · ")}`;
		return (
			<section className="build-card tk-card">
				<div className="build-card__head">
					<span className="build-card__title">Skills and tools</span>
					<span className="tk-muted">{draft ? `in draft ${draft.versionNumber}` : "suggested so far"}</span>
				</div>
				{skills.length === 0 && <div className="tk-muted">The guide suggests skills from the firm's library as the job becomes clear.</div>}
				{skills.map(this.renderSkill)}
				{this.renderRemovedSkills()}
				{isDraftBehind && <div className="playbook-build__source-note">You changed the skills since draft {draft.versionNumber}. Build again to use them.</div>}
				{this.renderTools({ tools })}
				<div className="build-card__guided-by">
					<button type="button" className="tk-text-action tk-text-action--muted" onClick={this.onToggleAboutGuide} aria-expanded={isAboutGuideShown}>
						{isAboutGuideShown ? <Icon.ChevronUp size={14} /> : <Icon.ChevronDown size={14} />}
						About this guide
					</button>
					{isAboutGuideShown && <div>{guidedByText}</div>}
				</div>
			</section>
		);
	}
}

export default PlaybookBuildSkillsCard;
